export default "__VITE_ASSET__DddjguHO__"